import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// turn of tip
Vue.config.productionTip = false
// promise polyfill
import { polyfill } from 'es6-promise';
polyfill();
// bootstrap vue
import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)
// scroll to
import VueScrollTo from 'vue-scrollto'
Vue.use(VueScrollTo, {
    offset: -90
})
// tooltip
import VTooltip from 'v-tooltip'
Vue.use(VTooltip)
// meta tags
import VueMeta from 'vue-meta'
Vue.use(VueMeta)
// check view
import checkView from 'vue-check-view'
Vue.use(checkView)
// google analytics
import VueAnalytics from 'vue-analytics'
Vue.use(VueAnalytics, {
  id: 'UA-112119644-28',
  router
})
// lodash
import VueLodash from 'vue-lodash'
const options = { name: 'lodash' }
Vue.use(VueLodash, options)
// svg.js
import svgJs from './plugins/vueSvgPlugin'
Vue.use(svgJs)
// creo custom plugin
import Creo from './plugins/creo'
Vue.use(Creo)
// font awesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import i18n from './i18n'
library.add(fas, far, fab)
Vue.component('font-awesome-icon', FontAwesomeIcon)
// init
new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
  mounted: () => document.dispatchEvent(new Event("x-app-rendered"))
}).$mount('#app')
